export default "__VITE_ASSET__0Kx9RfUs__"